type TombstoneMap = Record<string, true>;

function tombstoneKey(applicationId: string | number): string {
  return `lufeDocTombstone:${applicationId}`;
}

function readMap(applicationId: string | number): TombstoneMap {
  const raw = sessionStorage.getItem(tombstoneKey(applicationId));
  if (!raw) {
    return {};
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as TombstoneMap;
    }
  } catch {
    // ignore corrupt storage
  }
  return {};
}

function writeMap(applicationId: string | number, map: TombstoneMap): void {
  const key = tombstoneKey(applicationId);
  if (Object.keys(map).length === 0) {
    sessionStorage.removeItem(key);
    return;
  }
  sessionStorage.setItem(key, JSON.stringify(map));
}

export function setLufeDocTombstone(
  applicationId: string | number,
  type: string
): void {
  const map = readMap(applicationId);
  map[type] = true;
  writeMap(applicationId, map);
}

export function clearLufeDocTombstone(
  applicationId: string | number,
  type: string
): void {
  const map = readMap(applicationId);
  delete map[type];
  writeMap(applicationId, map);
}

export function isLufeDocTombstoned(
  applicationId: string | number,
  type: string
): boolean {
  return readMap(applicationId)[type] === true;
}
